export class TaskList {
    id = 0;
    name = '';
    tasks = [];
}
